import { useCallback } from 'react';
import { useStore } from '../store';

export function useCalculator() {
    const expression = useStore((s) => s.calcExpression);
    const result = useStore((s) => s.calcResult);
    const hasResult = useStore((s) => s.calcHasResult);
    const setExpression = useStore((s) => s.setCalcExpression);
    const setResult = useStore((s) => s.setCalcResult);
    const clear = useStore((s) => s.clearCalc);

    // Input digit - append to expression
    const inputDigit = useCallback(
        (digit: string) => {
            setExpression(expression + digit);
        },
        [expression, setExpression]
    );

    // Input operator - append with formatting
    const inputOperator = useCallback(
        (op: string) => {
            if (!expression) return; // Don't allow operator at start
            // Map to display symbols
            const displayOp = op === '*' ? '×' : op === '/' ? '÷' : op === '-' ? '−' : op;
            setExpression(expression + displayOp);
        },
        [expression, setExpression]
    );

    // Delete last character
    const deleteDigit = useCallback(() => {
        if (expression.length > 0) {
            setExpression(expression.slice(0, -1));
        }
    }, [expression, setExpression]);

    // Calculate result
    const calculate = useCallback(() => {
        if (!expression) return;
        try {
            // Replace display operators with JS operators
            const jsExpression = expression
                .replace(/×/g, '*')
                .replace(/÷/g, '/')
                .replace(/−/g, '-');

            console.log('Calculating:', jsExpression);
            const calcResult = new Function('return ' + jsExpression)();
            console.log('Result:', calcResult);

            const num = typeof calcResult === 'number' && !isNaN(calcResult) && isFinite(calcResult)
                ? Math.round(calcResult * 100) / 100
                : 0;
            setResult(num, true);
        } catch (e) {
            console.error('Calc error:', e);
            setResult(0, true);
        }
    }, [expression, setResult]);

    // Clear all
    const clearAll = useCallback(() => {
        clear();
    }, [clear]);

    return {
        expression,
        result,
        hasResult,
        inputDigit,
        inputOperator,
        deleteDigit,
        calculate,
        clear: clearAll,
    };
}
